import * as types from '../types/productTypes';
import * as productServices from '../../services/productServices';

export function fetchProducts(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PRODUCTS_REQUEST });
    try {
      const data = await productServices.fetchProducts(params);
      const list = Array.isArray(data) ? data : (data.products || data || []);
      dispatch({ type: types.FETCH_PRODUCTS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_PRODUCTS_FAILURE, payload: error.message });
    }
  };
}

export function fetchProductStats() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PRODUCT_STATS_REQUEST });
    try {
      const data = await productServices.fetchProductStats();
      dispatch({ type: types.FETCH_PRODUCT_STATS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_PRODUCT_STATS_FAILURE, payload: error.message });
    }
  };
}

export function fetchProductById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_PRODUCT_BY_ID_REQUEST });
    try {
      const data = await productServices.getProductById(id);
      dispatch({ type: types.FETCH_PRODUCT_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_PRODUCT_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function createProduct(payload) {
  return async (dispatch) => {
    dispatch({ type: types.CREATE_PRODUCT_REQUEST });
    try {
      const data = await productServices.createProduct(payload);
      dispatch({ type: types.CREATE_PRODUCT_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.CREATE_PRODUCT_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

export function updateProduct(id, payload) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_PRODUCT_REQUEST });
    try {
      const data = await productServices.updateProduct(id, payload);
      dispatch({ type: types.UPDATE_PRODUCT_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_PRODUCT_FAILURE, payload: error.message });
    }
  };
}

export function deleteProduct(id) {
  return async (dispatch) => {
    dispatch({ type: types.DELETE_PRODUCT_REQUEST });
    try {
      await productServices.deleteProduct(id);
      dispatch({ type: types.DELETE_PRODUCT_SUCCESS, payload: id });
    } catch (error) {
      dispatch({ type: types.DELETE_PRODUCT_FAILURE, payload: error.message });
    }
  };
}
